
<div class="node-status" v-if="nodeStatus">
  <span class="badge" :class="badgeClass" v-b-tooltip.hover :title="tooltipText">background processes</span>
</div>
